import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AlloyButton } from 'cat-ecommerce-alloy';
import { replaceTokensInUrl } from '../../../../utils';
import links from '../../../../constants/links';

const ContactDealerButton = props => {
  const { className, size, ...rest } = props;
  const storeId = useSelector(state => state.common.storeId);
  const langId = useSelector(state => state.common.langId);
  const catalogId = useSelector(state => state.common.catalogId);
  const [t] = useTranslation();
  const { CONTACT_DEALER_LINK } = links;

  const contactDealerLink = replaceTokensInUrl(
    CONTACT_DEALER_LINK,
    catalogId,
    langId,
    storeId
  );

  return (
    <AlloyButton
      className={className}
      size={size}
      buttonType="tertiary"
      onClick={() => (window.location.href = contactDealerLink)}
      {...rest}
    >
      {t('CONTACT_YOUR_DEALER')}
    </AlloyButton>
  );
};

ContactDealerButton.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string
};

export default ContactDealerButton;
